import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL || 'http://127.0.0.1:8001';

export const api = axios.create({
  baseURL: BASE,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

// Attach the access token from localStorage as a Bearer header (fallback when cookies blocked).
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('bymat_token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Format FastAPI 422 validation error arrays into a readable string.
export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || 'Something went wrong. Please try again.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).join(' · ');
  }
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}
